<template>
   <div class="campaign-container" :class="[activetab == 'list' ? 'list-view' : '', properties.content?.length == 0 ? 'shorten' : '']">
      <!-- Mobile Toggle Button -->
      <button class="campaign-toggle-button d-xxl-none" @click="mobileExpanded = !mobileExpanded">
         <span>{{ $t(properties?.name) }}</span>
         <i class="gts-icon icon-arrow-right" :class="{ expanded: mobileExpanded }"></i>
      </button>

      <!-- Desktop Header -->
      <div class="campaign-header-wrapper d-none d-xxl-block">
         <span>{{ $t(properties?.name) }}</span>
      </div>

      <div v-show="shouldShowContent" class="campaign-content-wrapper">
         <template v-if="properties.pending">
            <div class="widget-loader-wrapper">
               <span class="g-radial-loader"> </span>
            </div>
         </template>
         <template v-else-if="properties.content.length == 0">
            <span class="no-content">{{ $t("dashboardCampaigns_noContent") }}</span>
         </template>
         <template v-else>
            <b-tabs v-model="activetab">
               <b-tab-item value="list">
                  <section class="carousel-wrapper">
                     <div class="carousel-pagination-wrapper">
                        <div class="carousel-pagination-inner-wrapper">
                           <div class="pagination-prev-wrapper" @click="handlerSlidePrev">
                              <i class="gts-icon icon-arrow-right"></i>
                           </div>
                           <div class="pagination-next-wrapper" @click="handlerSlideNext">
                              <i class="gts-icon icon-arrow-right"></i>
                           </div>
                        </div>
                     </div>
                     <div class="swiper" ref="campaigns">
                        <div class="swiper-wrapper">
                           <div class="swiper-slide" v-for="(item, index) in properties.content" :key="index" @click="handlerShowDetail(item)">
                              <span class="campaign-title"> {{ item.name }}</span>
                              <div class="campaign-text" v-html="item.briefHtml"></div>
                              <span class="campaign-show-details-button">{{ $t("dashboardPage_lblShowDetails") }}</span>
                              <div class="campaign-remaining-days-container" :class="item.validDayCount < 4 && item.validDayCount > 0 ? '' : 'hide'">
                                 <i class="gts-icon icon-dashboard-campaings-countdown"></i>
                                 <span class="campaign-remaining-days-text">{{ handlerValidDayCount(item.validDayCount) }}</span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </section>
               </b-tab-item>
               <b-tab-item value="detail">
                  <Section class="campaign-detail-wrapper">
                     <div class="campaign-show-list" @click="activetab = 'list'">
                        <i class="gts-icon icon-arrow-full icon-sm"></i>
                        <span> {{ $t("dashboardPage_lblCampaignList") }}</span>
                     </div>
                     <div class="campaign-thumbnail-wrapper">
                        <img class="campaign-detail-thumbnail" :src="`${$constants.cdn}/announcements/${details.id}.jpg`" @click="openLightbox" />
                        <div class="campaign-thumbnail-overlay" @click="openLightbox">
                           <span>{{ $t("dashboardPage_lblCampaignThumbnail") }}</span>
                        </div>
                     </div>

                     <h2 class="detail-title">
                        {{ details.name }}
                     </h2>
                     <div class="campaign-detail" v-html="details.detailHtml"></div>

                     <div class="campaign-share-btn-wrapper">
                        <button class="campaign-share-button" @click="shareWithLogo">
                           <span>{{ $t("dashboardPage_lblShare") }}</span>
                        </button>
                     </div>
                  </Section>
               </b-tab-item>
            </b-tabs>
         </template>
      </div>
   </div>
</template>

<script>
export default {
   name: "Campaign",
   props: {
      properties: Object,
   },
   data() {
      return {
         activetab: "list",
         details: {},
         currentIndex: 0,
         myInterval: null,
         lightboxElement: null,
         mobileExpanded: false,
      };
   },
   computed: {
      isDesktop() {
         return window.innerWidth >= 1400;
      },
      shouldShowContent() {
         return this.isDesktop || this.mobileExpanded;
      },
   },
   mounted() {
      this.startAutoSlide();
   },
   beforeDestroy() {
      clearInterval(this.myInterval);
      if (this.lightboxElement) {
         document.body.removeChild(this.lightboxElement);
         this.lightboxElement = null;
      }
   },
   methods: {
      handlerShowDetail(item) {
         this.activetab = "detail";
         this.details = item;
      },
      handlerValidDayCount(val) {
         return this.$t("dashboardPage_lblValidDayCount").replace("#VALUE#", val);
      },
      handlerSlideNext() {
         if (!this.properties.content?.length) return;

         if (this.currentIndex + 1 === this.properties.content.length) {
            this.currentIndex = 0;
         } else {
            this.currentIndex++;
         }

         this.applySlideTransform();
         this.campaignsTimerClear();
      },
      handlerSlidePrev() {
         if (!this.properties.content?.length) return;

         if (this.currentIndex === 0) {
            this.currentIndex = this.properties.content.length - 1;
         } else {
            this.currentIndex--;
         }

         this.applySlideTransform();
         this.campaignsTimerClear();
      },
      startAutoSlide() {
         this.myInterval = setInterval(() => {
            this.handlerSlideNext();
         }, 8000);
      },
      campaignsTimerClear() {
         clearInterval(this.myInterval);
         this.startAutoSlide();
      },
      applySlideTransform() {
         const wrapper = this.$el.querySelector(".swiper-wrapper");
         if (wrapper) {
            wrapper.style.transform = `translateX(-${this.currentIndex * 100}%)`;
            wrapper.style.transition = "transform 0.5s ease-in-out";
         }
      },
      openLightbox() {
         const lightboxOverlay = document.createElement("div");
         lightboxOverlay.className = "campaign-lightbox-overlay";
         lightboxOverlay.addEventListener("click", this.closeLightbox);

         const lightboxContent = document.createElement("div");
         lightboxContent.className = "campaign-lightbox-content";
         lightboxContent.addEventListener("click", (e) => e.stopPropagation());

         const closeButton = document.createElement("button");
         closeButton.className = "campaign-lightbox-close";
         closeButton.innerHTML = '<i class="gts-icon icon-close-rounded"></i>';
         closeButton.addEventListener("click", this.closeLightbox);

         const image = document.createElement("img");
         image.src = `${this.$constants.cdn}/announcements/${this.details.id}.jpg`;
         image.alt = "Campaign Detail";
         image.className = "campaign-lightbox-image";

         lightboxContent.appendChild(closeButton);
         lightboxContent.appendChild(image);
         lightboxOverlay.appendChild(lightboxContent);

         document.body.appendChild(lightboxOverlay);
         this.lightboxElement = lightboxOverlay;
         this.activetab = "list";
         this.details = {};
      },
      closeLightbox() {
         if (this.lightboxElement) {
            document.body.removeChild(this.lightboxElement);
            this.lightboxElement = null;
         }
      },
      async shareWithLogo() {
         const canvas = document.createElement("canvas");
         const ctx = canvas.getContext("2d");

         const campaignImg = new Image();
         campaignImg.crossOrigin = "anonymous";
         campaignImg.src = `${this.$constants.cdn}/announcements/${this.details.id}.jpg`;

         campaignImg.onload = async () => {
            canvas.width = campaignImg.width;
            canvas.height = campaignImg.height;

            // Draw campaign image
            ctx.drawImage(campaignImg, 0, 0, canvas.width, canvas.height);

            // Load and draw logo
            const logoImg = new Image();
            logoImg.crossOrigin = "anonymous";
            const agencyID = this.$store.state.user.user.onBehalfOfs.agencyOnBehalfOfId;
            console.log(this.$store.state.user.user);
            logoImg.src = `https://cdn.reisetech.io/logo_agency/${agencyID}.jpg`;

            logoImg.onload = async () => {
               // Calculate logo size based on canvas dimensions
               const logoWidth = canvas.width * 0.2; // 15% of canvas width
               const logoHeight = (logoImg.height / logoImg.width) * logoWidth;
               const padding = canvas.width * 0.025; // 2.5% of canvas width as padding

               // Draw white rect
               ctx.fillStyle = "white";
               const rectWidth = 300;
               const rectHeight = 180;
               const rectX = canvas.width - rectWidth;
               const rectY = canvas.height - rectHeight;
               ctx.fillRect(rectX, rectY, rectWidth, rectHeight);

               ctx.drawImage(logoImg, canvas.width - logoWidth - padding, canvas.height - logoHeight - padding, logoWidth, logoHeight);

               // Get image data
               const imageData = canvas.toDataURL("image/png");

               // Check if navigator.share is available
               if (navigator.share) {
                  const blob = await fetch(imageData).then((r) => r.blob());
                  const file = new File([blob], `campaign-${this.details.id}.png`, { type: "image/png" });

                  if (navigator.canShare && navigator.canShare({ files: [file] })) {
                     try {
                        await navigator.share({
                           files: [file],
                           title: this.details.name,
                           text: this.details.name,
                        });
                        return;
                     } catch (err) {
                        if (err.name !== "AbortError") {
                           console.error("Share failed:", err);
                        }
                     }
                  }
               }

               // Fallback: download the image
               const link = document.createElement("a");
               link.download = `campaign-${this.details.id}.png`;
               link.href = imageData;
               link.click();
            };

            logoImg.onerror = async () => {
               console.error("Failed to load logo");
               // Generate without logo if logo fails
               const imageData = canvas.toDataURL("image/png");

               // Check if navigator.share is available
               if (navigator.share) {
                  const blob = await fetch(imageData).then((r) => r.blob());
                  const file = new File([blob], `campaign-${this.details.id}.png`, { type: "image/png" });

                  if (navigator.canShare && navigator.canShare({ files: [file] })) {
                     try {
                        await navigator.share({
                           files: [file],
                           title: this.details.name,
                           text: this.details.name,
                        });
                        return;
                     } catch (err) {
                        if (err.name !== "AbortError") {
                           console.error("Share failed:", err);
                        }
                     }
                  }
               }

               // Fallback: download the image
               const link = document.createElement("a");
               link.download = `campaign-${this.details.id}.png`;
               link.href = imageData;
               link.click();
            };
         };

         campaignImg.onerror = () => {
            console.error("Failed to load campaign image");
         };
      },
   },

   watch: {
      "properties.pending": {
         handler: function (status) {
            if (!status) {
               this.activetab = "list";
               this.$nextTick(() => {
                  this.currentIndex = 0;
                  this.applySlideTransform();
               });
            }
         },
         deep: true,
         immediate: true,
      },
      activetab(val) {
         if (val === "list") {
            this.details = {};
            this.startAutoSlide();
         } else {
            clearInterval(this.myInterval);
         }
      },
   },
};
</script>

<style lang="scss" scoped>
@keyframes attention {
   0% {
      background-color: var(--primary);
   }
   50% {
      background-color: var(--primary);
   }
   100% {
      background-color: var(--accent-primary);
   }
}

.campaign-container {
   background-color: var(--light-bg-primary_dark-bg-dark-gray);

   border-radius: 1rem;
   padding: 1.5rem;

   margin-bottom: 1.5rem;
   animation-name: attention;
   animation-fill-mode: backwards;
   animation-iteration-count: 4;
   animation-timing-function: ease-out;
   animation-duration: 0.35s;
   animation-delay: 1s;

   @media (max-width: 1399px) {
      padding: 0;
      margin-bottom: 0;
   }

   .campaign-toggle-button {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 1.5rem;
      background: transparent;
      border: none;
      cursor: pointer;
      transition: all 0.3s ease;

      span {
         color: var(--teal-400);
         font-size: var(--large);
         font-weight: 600;
         text-align: left;
      }

      i {
         transition: transform 0.3s ease;
         transform: rotate(90deg);
         filter: brightness(10);
         font-size: 1.2rem;

         &.expanded {
            transform: rotate(-90deg);
         }
      }

      &:hover {
         opacity: 0.9;
      }
   }

   .campaign-content-wrapper {
      @media (max-width: 1399px) {
         padding: 0 1.5rem 1.5rem;
      }

      @media (min-width: 1400px) {
         display: block !important;
      }
   }

   .no-content {
      //color: var(--gray-50);
      color: var(--gray-0);
      font-size: var(--large);
   }

   .widget-loader-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6rem;
      .g-radial-loader {
         $size: 42px;
         width: $size;
         height: $size;
         border-width: 4px;
         border-color: var(--gray-50);
      }
   }

   &.list-view {
      @media (min-width: 1400px) {
         min-height: 354px;
      }
   }
   &.shorten {
      height: auto;
   }
   .campaign-header-wrapper {
      border-bottom: 1px solid var(--gray-200);
      padding-bottom: 0.5rem;
      margin-bottom: 0.5rem;
      span {
         color: var(--teal-400);
         font-size: var(--large);
         font-weight: 600;
      }
   }
   .carousel-wrapper {
      position: relative;
      height: 100%;
      .swiper-slide {
         border-radius: 1rem;

         padding: 0.75rem;
         box-sizing: border-box;
         cursor: pointer;
         &:hover {
            background-color: var(--gray-0-alpha-75);
         }
      }

      .campaign-title {
         display: block;

         font-size: 2rem;
         color: var(--txt-white);
         font-weight: 600;
         line-height: 2.35rem;
      }
      .campaign-text {
         padding-top: 0.5rem;
         color: var(--txt-white) !important;
         line-height: 1.25rem;
         p > strong {
            color: var(--txt-white) !important;
         }
      }
      .campaign-show-details-button {
         display: block;
         color: var(--teal-400);
         font-weight: 600;
         text-decoration: underline;
         margin-top: 0.5rem;
      }
      .campaign-remaining-days-container {
         margin-top: 1rem;
         display: inline-flex;
         padding: 0.25rem 0.5rem;
         padding-right: 1rem;
         align-items: center;
         font-weight: 600;
         background-color: var(--teal-400);
         border-radius: 0.5rem;
         i {
            $dim: 22px;
            width: $dim !important;
            height: $dim !important;
         }
         span {
            margin-left: 0.5rem;
         }
         &.hide {
            display: none;
         }
      }

      .carousel-pagination-wrapper {
         display: flex;
         justify-content: flex-end;
         position: absolute;
         width: fit-content;
         z-index: 100;
         bottom: 8px;
         right: 0;
         .carousel-pagination-inner-wrapper {
            background: var(--primary);
            display: flex;

            .pagination-prev-wrapper {
               border-right: none !important;
               i {
                  transform: rotate(-180deg);
               }
            }
            .pagination-prev-wrapper,
            .pagination-next-wrapper {
               cursor: pointer;
               display: flex;
               align-items: center;
               justify-content: center;
               $dim: 38px;
               width: $dim;
               height: $dim;
               border: 2px solid var(--gray-50);

               i {
                  filter: brightness(10);
                  $dim: 25px !important;
                  width: $dim;
                  height: $dim;
                  display: block;
               }

               &:hover {
                  background-color: var(--gray-0-alpha-75);
               }
            }
         }
      }
   }
   section.campaign-detail-wrapper {
      //color: var(--gray-50);
      color: var(--gray-0);
      padding: 0 0.5rem;

      .campaign-share-btn-wrapper {
         display: flex;
         justify-content: flex-start;
         margin-top: 1rem;
         position: relative;

         .campaign-share-button {
            display: inline-flex;
            align-items: center;

            padding: 0.5rem 0.75rem;

            background: var(--txt-white);
            color: var(--txt-black);
            border: none;
            border-radius: 0.5rem;
            font-size: var(--small);
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s ease;

            i {
               font-size: 1.2rem;
            }

            &:hover {
               opacity: 0.9;
               transform: translateY(-2px);
               box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }

            &:active {
               transform: translateY(0);
            }
         }
      }

      .campaign-thumbnail-wrapper {
         position: relative;
         display: inline-block;

         .campaign-detail-thumbnail {
            border-radius: 0.5rem;
            cursor: pointer;
            display: block;
         }

         .campaign-thumbnail-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: var(--gray-1000-alpha-50);
            border-radius: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: opacity 0.3s ease;
            cursor: pointer;

            span {
               //color: var(--gray-50);
               color: var(--gray-0);
               font-size: 1rem;
               font-weight: 500;
               text-align: center;
               padding: 0.5rem;
            }
         }

         &:hover .campaign-thumbnail-overlay {
            opacity: 1;
         }
      }
      h2.detail-title {
         font-size: var(--large);
         font-weight: 600;
         margin-top: 0.5rem;
      }
      .campaign-show-list {
         display: flex;
         margin-bottom: 1rem;

         i {
            transform: rotate(-180deg);
            filter: brightness(10);
         }

         span {
            margin-left: 0.5rem;
            font-weight: 500;
         }
         &:hover {
            cursor: pointer;
         }
      }
   }
}
</style>

<style lang="scss">
.campaign-container {
   position: relative;
   display: flex;
   flex-direction: column;
   .b-tabs {
      height: 100%;
      position: relative;

      .tabs {
         display: none;
      }
      .tab-content {
         padding: 0 !important;
         height: 100%;

         .tab-item {
            height: 100%;
         }
      }
   }
}

.campaign-text {
   padding-top: 0.5rem;
   color: var(--txt-white) !important;
   line-height: 1.25rem;
   p > strong {
      color: var(--txt-white) !important;
   }
}

section.campaign-detail-wrapper {
   .campaign-detail {
      color: var(--txt-white) !important;
      a {
         color: var(--primary);
         font-weight: 500;
      }
      p {
         text-indent: 0rem !important;
      }
      strong {
         //color: var(--gray-50);
         color: var(--txt-white) !important;
      }
   }
}

.campaign-lightbox-overlay {
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background-color: var(--gray-1000-alpha-25);
   display: flex;
   align-items: center;
   justify-content: center;
   z-index: 10000;
}

.campaign-lightbox-content {
   position: relative;
   max-width: 90%;
   max-height: 90vh;
   background: var(--gray-50);
   border-radius: 1rem;
   padding: 0.5rem;
   box-sizing: content-box;

   img {
      border-radius: 1rem;
   }
}

.campaign-lightbox-close {
   position: absolute;
   top: -10px;
   right: -10px;
   border: none;
   border-radius: 100%;
   width: 42px !important;
   height: 42px !important;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
   background-color: var(--gray-50) !important;
   box-sizing: border-box;

   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
   background-color: var(--gray-50) !important;

   i {
      font-size: 20px;
      color: var(--gray-800);
   }

   &:hover {
      background-color: var(--gray-100);
   }
}

.campaign-lightbox-image {
   max-width: 100%;
   max-height: 85vh;
   width: auto;
   height: auto;
   object-fit: contain;
   border-radius: 0.5rem;
}
</style>
